import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MatLegacyDialogConfig as MatDialogConfig, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { RankDialogComponent } from 'src/app/views/partials/dialogs/rank-dialog/rank-dialog.component';

@Component({
  selector: 'app-show-result-dialog',
  templateUrl: './show-result-dialog.component.html',
  styleUrls: ['./show-result-dialog.component.scss']
})
export class ShowResultDialogComponent implements OnInit {
  studentModel;
  title;
  examId;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ShowResultDialogComponent>,
    private router: Router,
    private dialog: MatDialog,


  ) {
    this.title = data.title;
    this.studentModel = data.data;
    this.examId = data.exam_id

    console.log('this.studentModel this.studentModel', this.studentModel);

  }

  ngOnInit(): void {
    this.showExamRank()
  }



  onGoToExams() {
    this.dialogRef.close();
    this.router.navigate(['/practice-exam'])
  }

  calculateClass(index, percent) {
    // console.log('percentpercentpercentpercent', index, percent);

    if (percent >= 0) {
      return `progress${index} plus`;
    }
    return `progress${index} minus`;
  }
  calculateColor(percent) {
    if (percent < 25) {
      return 'rgba(217, 54, 54, 1)'
    } else if (percent > 25 && percent <= 50) {
      return '#f7a62b'
    }
    else if (percent > 50 && percent <= 75) {
      return '#00CCFF'
    }
    else {
      return '#00DE08'
    }
  }
  reloadExam() {
    // this.router.navigate(['exam'], queryParams: { examId: this.examId },)
    this.router.navigate(['/exam'], {
      queryParams: { examId: this.examId, examType: '2' },
    });
    this.dialog.closeAll()
    // window.location.reload();
  }
  showExamRank() {

    setTimeout(() => {
      this.studentModel.categories.forEach((item, index) => {

        const progress = new CircleProgress(`.progress${index}`, {
          max: 100,
          value: item.percent >= 0 ? Math.round(item.percent) : -Math.round(item.percent),
          textFormat: function (value) {
            // if (value >= 0) {
            return Math.round(item.percent) + '%';
            // }
            // return item.percentage + '%';
          },
          width: 50,
          height: 50,
        });
      });
    }, 100);
  }


  showRanking() {
    this.dialog.open(RankDialogComponent, {
      data: { examId: this.examId }
    });
  }
  gotoResult() {
    console.log('change route to exam resulttttttttttttttttt', this.title);

    this.router.navigate(['result'], { queryParams: { examId: this.examId, title: this.title } });

    this.dialogRef.close();
  }
}
